import { render } from "./PurchaseNakshatraInfluenceReport.vue?vue&type=template&id=a9d044fc&scoped=true"
import script from "./PurchaseNakshatraInfluenceReport.vue?vue&type=script&lang=js"
export * from "./PurchaseNakshatraInfluenceReport.vue?vue&type=script&lang=js"

import "./PurchaseNakshatraInfluenceReport.vue?vue&type=style&index=0&id=a9d044fc&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2221027770/src/vedicastrologyreport-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9d044fc"]])

export default __exports__